<template>
  <div :id="`${singularizeIndex(index)}-${parsedResultData.slug}`"
    @click="linkToResult($event, $route.name)"
    @click.middle="redirectMiddleClick($event)"
    class="card-wrapper"
  >
    <v-popover :offset="`1`"
      :container="`#${singularizeIndex(index)}-${parsedResultData.slug}`"
      :boundariesElement="`viewport`"
      :trigger="hasPopover && !isEmptyPopover ? 'hover' : 'none'"
      :open="false"
      :popoverClass="`popover-search-result`"
      :popoverWrapperClass="`hide-for-touch d-none d-md-block`"
      :delay="{ show: 1000, hide: 0 }"
      :placement="`bottom`"
      @show="fetchHighlights"
    >
      <component :is="componentContentName"
        :highlights="computedHighlights"
        :highlightsLoading="!highlightsLoaded"
        :matches="matches"
        :index="index"
        :data="parsedResultData"
        class="card card-block"
        :class="classes"
        :link="getRoute"
      >
        <template #actions>
          <base-actions
            :index="index"
            :data="parsedResultData"
            :link="getRoute"
          />
        </template>
      </component>

      <template #popover v-if="hasPopover">
        <component
          :is="componentPopoverName"
          :highlights="computedHighlights"
          :highlightsLoading="!highlightsLoaded"
          :matches="matches"
          :index="index"
          :data="parsedResultData"
          @setIsEmptyPopover="setIsEmptyPopover">
        </component>
      </template>
    </v-popover>

    <div class="label-search-result">
      <span v-if="isOutOfBusiness"
        class="label-base bg-red"
        v-tooltip="'Our sources indicate this company is out of business.'"
      >CLOSED</span>
      <span v-else-if="isNew" class="label-base bg-yellow">NEW</span>
      <img
        v-if="result.data.is_open_access"
        class="ml-2"
        :src="require('@/assets/img/icon/open_access.svg')"
        style="height: 20px; width: 12.8px;">
    </div>
  </div>
</template>

<script>
import ResearchGroupResultBlock from '@/components/research_group/result/Block'
import ResearchGroupResultPopover from '@/components/research_group/result/Popover'
import PublicationResultBlock from '@/components/publication/result/Block'
import PublicationResultPopover from '@/components/publication/result/Popover'
import ResearcherResultBlock from '@/components/researcher/result/Block'
import ResearcherResultPopover from '@/components/researcher/result/Popover'
import ProjectResultBlock from '@/components/project/result/Block'
import ProjectResultPopover from '@/components/project/result/Popover'
import PatentResultBlock from '@/components/patent/result/Block'
import PatentResultPopover from '@/components/patent/result/Popover'
import ResearchTopicResultBlock from '@/components/research_topic/result/Block'
import ResearchTopicResultPopover from '@/components/research_topic/result/Popover'
import ClinicalTrialResultBlock from '@/components/clinical_trial/result/Block'
import ClinicalTrialResultPopover from '@/components/clinical_trial/result/Popover'
import OrganisationResultBlock from '@/components/organisation/result/Block'
import OrganisationResultPopover from '@/components/organisation/result/Popover'
import NewsResultBlock from '@/components/news/result/Block'
import BaseActions from '@/components/search/results/BaseActions'

import highlights from '@/mixins/highlights'
// resultHelpers is where most of the functionality of this component is located (computed properties, methods, ...)
import resultHelpers from '@/mixins/search/resultHelpers'

export default {
  name: 'searchResultBaseBlock',
  mixins: [highlights, resultHelpers],
  components: {
    BaseActions,
    ResearchGroupResultBlock,
    ResearchGroupResultPopover,
    PublicationResultBlock,
    PublicationResultPopover,
    ResearcherResultBlock,
    ResearcherResultPopover,
    ProjectResultBlock,
    ProjectResultPopover,
    PatentResultBlock,
    PatentResultPopover,
    ResearchTopicResultBlock,
    ResearchTopicResultPopover,
    ClinicalTrialResultBlock,
    ClinicalTrialResultPopover,
    OrganisationResultBlock,
    OrganisationResultPopover,
    NewsResultBlock
  },
  props: {
    index: {
      type: String,
      required: true
    },
    result: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      classes: [`card-block--${this.singularizeIndex(this.index)}`]
    }
  },
  computed: {
    componentContentName () {
      return `${this.cleanedIndex}ResultBlock`
    },
    componentPopoverName () {
      return `${this.cleanedIndex}ResultPopover`
    }
  }
}
</script>
